// extracted by mini-css-extract-plugin
export default {"productCarousel":"CZ-z"};